!(function (n) {
    'use strict';
    function e(n, e, r, t, o) {
        var a = new XMLHttpRequest();
        (a.open(n, e, !0),
            a.setRequestHeader('Client-SDK', 'js4.1.0'),
            (a.onreadystatechange = function () {
                4 === a.readyState &&
                    (a.status >= 200 && a.status < 400
                        ? t && t(a)
                        : o &&
                          o &&
                          o(
                              new Error(
                                  'Server responded with HTTP ' + a.status
                              ),
                              a
                          ));
            }),
            o && (a.onerror = o),
            a.send(r));
    }
    function r(n) {
        var e = [];
        for (var r in n)
            n.hasOwnProperty(r) &&
                e.push(encodeURIComponent(r) + '=' + encodeURIComponent(n[r]));
        return e.join('&');
    }
    function t(n) {
        var e = {};
        if ('object' != typeof n || !n) return e;
        for (var r in n) n.hasOwnProperty(r) && (e[r] = n[r]);
        return e;
    }
    ((!1) in new XMLHttpRequest() && (e = function () {}),
        (n.Adjust = function (n) {
            var o = t((n = n || {}).device_ids);
            return (
                (o.app_token = n.app_token),
                (o.environment = n.environment),
                (o.os_name = n.os_name || 'android'),
                console.log(o),
                {
                    trackSession: function (n, a) {
                        e(
                            'GET',
                            'https://app.adjust.com/session?' + r(t(o)),
                            null,
                            n,
                            a
                        );
                    },
                    trackEvent: function (n, u, s) {
                        n = n || {};
                        var c = t(o),
                            i = (function (n) {
                                var e = parseFloat(n.revenue);
                                if (e < 0 || !n.currency) return null;
                                return {
                                    revenue: e.toFixed(5),
                                    currency: n.currency,
                                };
                            })(n),
                            p = a(n.callback_params),
                            v = a(n.partner_params);
                        ((c.event_token = n.event_token),
                            i &&
                                ((c.revenue = i.revenue),
                                (c.currency = i.currency)));
                        p && (c.callback_params = JSON.stringify(p));
                        v && (c.partner_params = JSON.stringify(v));
                        e(
                            'GET',
                            'https://app.adjust.com/event?' + r(c),
                            null,
                            u,
                            s
                        );
                    },
                }
            );
            function a(n) {
                if (!(n = n || []).length) return null;
                for (var e = {}, r = 0; r < n.length; r++)
                    e[n[r].key] = n[r].value;
                return t(e);
            }
        }));
})(window);
